import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { throwError } from '../../../throwError';
import { handleError } from '../../../handleError';
import { api } from '../../../../server/api';

export function* fetchChannels() {
  try {
    yield effects.put(chatActions.startFetching());
    const response = yield effects.apply(api, api.get, [
      { endpoint: 'chats/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(chatActions.fillChannels(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
